"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateHouseholdAgesHelpPopup = exports.householdCarNumberHelpPopup = exports.householdSizeHelpPopup = exports.cityHelpPopup = void 0;
const helpers_1 = require("evolution-common/lib/utils/helpers");
const odSurveyHelpers = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const frontendHelper_1 = require("evolution-frontend/lib/services/display/frontendHelper");
// import { countPersons, getPersonsObject, selfResponseAge } from '../helperFunctions/helper';
exports.cityHelpPopup = {
    title: {
        fr: 'Quoi écrire si ce n\'est pas une ville ?',
        en: 'What to write if it\'s not a city?'
    },
    content: {
        fr: function (_interview, _path) {
            return 'Vous pouvez aussi mettre le nom de votre village, municipalité ou réserve autochtone';
        },
        en: function (_interview, _path) {
            return 'You can also put the name of your village, county or indigeneous reserve.';
        }
    }
};
// TODO: Use the assignedDate from the interview object instead of the date of the survey.
// TODO: Update the assignedDate from serverFieldUpdate.ts and test it from serverFieldUpdate.test.ts
exports.householdSizeHelpPopup = {
    title: {
        fr: 'Qui inclure dans ce nombre ?',
        en: 'Who to include?'
    },
    containsHtml: true,
    content: (t, interview) => {
        // assigned date should be the day before the interview started:
        const assignedDay = (0, helpers_1.getResponse)(interview, '_assignedDay');
        const assignedDate = (0, frontendHelper_1.getFormattedDate)(assignedDay, { withDayOfWeek: true, withRelative: true });
        return t('customLabel:HomeHouseholdSizeHelpContent', {
            assignedDate
        });
    }
};
exports.householdCarNumberHelpPopup = {
    title: {
        fr: 'Quels véhicules inclure dans ce nombre?',
        en: 'Which vehicles to include?'
    },
    content: {
        fr: function (_interview, _path) {
            return `
* **Inclure les automobiles, VUS, camions légers, camions, fourgonnettes**
* **Inclure tous les véhicules fournis ou loués par un employeur que les membres de votre ménage utilisent pour aller au travail ou pour des raisons personnelles**
* ~~Ne pas inclure les mobylettes, scooters et motos (à essence ou électriques)~~
* ~~Ne pas inclure les véhicules d'autopartage~~
* ~~Ne pas inclure un véhicule stationné au lieu de travail utilisé exclusivement pour le travail~~
* ~~Ne pas inclure les vélos ou vélos électriques~~
* ~~Ne pas inclure les trottinettes (électriques ou non)~~
* ~~Ne pas inclure les véhicules remisés ou de collection utilisés rarement~~
`;
        },
        en: function (_interview, _path) {
            return `
* **Include cars, SUV, light-duty trucks, trucks, vans**
* **Include all vehicles made available or leased by an employer that members of your household use to go to work or for personal reasons**
* ~~Do not include moped, scooters and motorcycles (gas or electric)~~
* ~~Do not include carsharing vehicles~~
* ~~Do not include a vehicle parked at work and used exclusively for work~~
* ~~Do not include bicycles or electric bicycles~~
* ~~Do not include kick scooters or electric scooters~~
* ~~Do not include stowed vehicles or collection vehicles used rarely~~
`;
        }
    }
};
exports.validateHouseholdAgesHelpPopup = {
    content: (t, interview, path) => {
        const countPersons = odSurveyHelpers.countPersons({ interview });
        return t('household:popup.validateHouseholdAgesHelp', {
            count: countPersons
        });
    },
    showConfirmButton: false,
    cancelButtonColor: 'blue',
    cancelButtonLabel: {
        fr: 'OK',
        en: 'OK'
    },
    conditional: function (interview) {
        const persons = odSurveyHelpers.getPersonsArray({ interview });
        const allPersonsHaveAge = persons.find((person) => (0, LodashExtensions_1._isBlank)(person.age)) === undefined;
        // FIXME Why 16? In the config, we have selfResponseMinimumAge, interviewableAge, adultAge, drivingLicenseAge Can we use one of those instead?
        const atLeastOnePersonOlderThan16 = persons.find((person) => !(0, LodashExtensions_1._isBlank)(person.age) && person.age >= 16) !== undefined;
        return allPersonsHaveAge && !atLeastOnePersonOlderThan16;
    }
};
